export default "__VITE_ASSET__lamvwf00__"